import React from 'react';
import { ArcStack } from '@src/core/ui';
import { HistoryOrdersSidebar, HistoryOrdersContent } from './orders';

const HistoryPage: React.FC = () => {
  return (
    <ArcStack direction='row'>
      <HistoryOrdersSidebar />
      <HistoryOrdersContent />
    </ArcStack>
  );
};

export { HistoryPage };
